export default "__VITE_ASSET__DVjABNvd__"